import { Form, Input, Button, message, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBatteryUser } from "../../actions/user";
import images from "../../assets/images";
import Batteries from "./Batteries";
import { batteryApiRequest, BatteryContext } from "./common";

function Screen() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.token.batteryUser);
  const [batteries, setBatteries] = useState([]);

  const getBatteries = async (user) => {
    let res = await batteryApiRequest({ path: "/batteries", token: user });
    if (res.error) {
      message.error(res.error_description);
      return;
    }
    let batteriesObj = res.results.reduce((batteries, battery) => {
      batteries[battery._id] = battery;
      return batteries;
    }, {});
    setBatteries(batteriesObj);
    return res;
  };

  useEffect(() => {
    if (user) {
      getBatteries(user.token);
    }
  }, []);

  const onFinish = async (values) => {
    let user = values.username + "-" + values.password;
    let userData = await getBatteries(user);
    dispatch(setBatteryUser(userData.user));
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <BatteryContext.Provider value={{ batteries, setBatteries }}>
      {!user ? (
        <div
          className="flex shadow"
          style={{
            width: "90%",
            height: "90%",
            flexDirection: "column",
            backgroundColor: "#fff",
            padding: "5%",
          }}
        >
          <Typography.Title>Upciti Battery Admin Panel</Typography.Title>
          <div
            style={{
              marginTop: 50,
              alignItems: "center",
              justifyContent: "space-around",
              display: "flex",
              width: "80%",
              flexWrap: "wrap",
            }}
          >
            <img src={images.upcitiLogo} style={{ width: 300 }} />

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                marginTop: 40,
              }}
              // className={classNames.loginForm}
            >
              <Form
                name="basic"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 24 }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                <Form.Item
                  label={"Username"}
                  name="username"
                  rules={[
                    { required: true, message: "Please input your username!" },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    { required: true, message: "Please input your password!" },
                  ]}
                >
                  <Input.Password />
                </Form.Item>

                <Form.Item wrapperCol={{ offset: 8 }}>
                  <Form.Item
                    wrapperCol={{ offset: 8 }}
                    style={{ marginTop: 10 }}
                  >
                    <Button type="primary" htmlType="submit">
                      Login
                    </Button>
                  </Form.Item>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            // padding: "0 5%",
            backgroundColor: "#fff",
            width: "100%",
            height: "100%",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 9999,
              padding: "1% 2%",
              backgroundColor: "#00000050",
            }}
          >
            <Button
              onClick={() => {
                dispatch(setBatteryUser(null));
              }}
            >
              Logout
            </Button>
          </div>
          <Batteries user={user} />
        </div>
      )}
    </BatteryContext.Provider>
  );
}

export default Screen;
